import React, { useEffect, useState, createContext } from 'react'
import DataV from './components/cangku'
import ZhuChang from './components/zhuchang'
import Keshi from './components/keshi'
import CangkuDaily from './components/cangku_daily'
import No10 from './components/No10'
import No10KeShi from './components/No10/KS'
import XYFY from './components/xyfy'
import XYFYKeShi from './components/xyfy/KS'
import PTZXZC from './components/ptzx/zc'
import './App.css'
import { queryServer } from './service/request'
import Error from './components/common/Error'
import { FullScreenContainer } from '@jiaminghi/data-view-react'

export const DataContext = createContext({})

function getData(setDataFunction, type) {
  if (type.name === 'cangKu') {
    queryServer(
      type.domain + '/api/v2/probe/action/summary_statistics?field=depository',
      function(res) {
        setDataFunction(res.data)
      },
      type.fp
    )
  }
  if (type.name === 'zhuChang') {
    queryServer(
      type.domain + '/api/v2/probe/action/summary_statistics?field=hospital_storage',
      function(res) {
        setDataFunction(res.data)
      },
      type.fp
    )
  }

  if (type.name === 'keShi') {
    queryServer(
      type.domain + '/api/v2/probe/action/summary_statistics?field=hospital_department',
      function(res) {
        setDataFunction(res.data)
      },
      type.fp
    )
  }

  if (type.name === 'cangKu_daily') {
    queryServer(
      type.domain + '/api/v2/probe/action/summary_statistics?field=depository_todo_list',
      function(res) {
        setDataFunction(res.data)
      },
      type.fp
    )
  }

  if (type.name === 'shiYuan' || type.name === 'XYFY') {
    queryServer(
      type.domain + '/api/v2/probe/action/summary_statistics?field=laboratory_monitor',
      function(res) {
        res.data.request_time = new Date()
        setDataFunction(res.data)
      },
      type.fp
    )
  }

  if (type.name === 'shiYuan_ks' || type.name === 'XYFY_ks') {
    queryServer(
      type.domain + '/api/v2/probe/action/summary_statistics?field=resident_monitor',
      function(res) {
        res.data.request_time = new Date()
        setDataFunction(res.data)
      },
      type.fp
    )
  }

  if (type.name === 'ptzx_zc') {
    queryServer(
      type.domain + '/api/v2/probe/action/summary_statistics?field=resident_monitor',
      function(res) {
        res.data.request_time = new Date()
        setDataFunction(res.data)
      },
      type.fp
    )
  }
}

function App() {
  const [data, setData] = useState({})
  const hasRequestError = data && data.message

  const [type, setType] = useState({
    name: '',
    domain: '',
    fp: '',
  })

  useEffect(() => {
    let final_obj = {
      name: '',
      domain: '',
      fp: '',
    }
    const urlParams = new URLSearchParams(window.location.search)
    const type = urlParams.get('type')
    // 指定类型
    if (type) {
      if (type.toUpperCase().indexOf('CK') >= 0) {
        final_obj.name = 'cangKu'
      }
      if (type.toUpperCase().indexOf('ZC') >= 0) {
        final_obj.name = 'zhuChang'
      }
      if (type.toUpperCase().indexOf('KS') >= 0) {
        final_obj.name = 'keShi'
      }
      if (type.toUpperCase().indexOf('CKD') >= 0) {
        final_obj.name = 'cangKu_daily'
      }
      if (type.toUpperCase().indexOf('SY') >= 0) {
        final_obj.name = 'shiYuan'
      }
      if (type.toUpperCase().indexOf('SY_KS') >= 0 || type.toUpperCase().indexOf('SY_ZC') >= 0) {
        final_obj.name = 'shiYuan_ks'
      }
      if (type.toUpperCase().indexOf('XYFY') >= 0) {
        final_obj.name = 'XYFY'
      }
      if (
        type.toUpperCase().indexOf('XYFY_KS') >= 0 ||
        type.toUpperCase().indexOf('XYFY_ZC') >= 0
      ) {
        final_obj.name = 'XYFY_ks'
      }
      if (type.toUpperCase().indexOf('PTZX_ZC') >= 0) {
        final_obj.name = 'ptzx_zc'
      }
    }

    // 手动指定域
    const currentDomain = urlParams.get('domain')
    if (currentDomain) {
      final_obj.domain = currentDomain
    }

    // 手动指定指纹
    const force_fp = urlParams.get('force_fp')
    if (force_fp) {
      final_obj.fp = force_fp
    }
    setType(final_obj)
  }, [])

  useEffect(() => {
    getData(setData, type)

    const timer = setInterval(() => {
      getData(setData, type)
    }, 60000 * 10)

    return () => clearInterval(timer)
  }, [type])

  return (
    <DataContext.Provider value={data}>
      <div id="app">
        {hasRequestError && (
          <div id="data-view">
            <FullScreenContainer>
              <Error data={data} />
            </FullScreenContainer>
          </div>
        )}
        {!hasRequestError && type.name === 'cangKu_daily' && (
          <div id="data-view">
            <FullScreenContainer>
              <CangkuDaily data={data} />
            </FullScreenContainer>
          </div>
        )}
        {!hasRequestError && type.name === 'cangKu' && <DataV data={data} />}
        {!hasRequestError && type.name === 'zhuChang' && <ZhuChang data={data} />}
        {!hasRequestError && type.name === 'keShi' && <Keshi data={data} />}
        {!hasRequestError && type.name === 'shiYuan' && <No10 data={data} />}
        {!hasRequestError && type.name === 'shiYuan_ks' && <No10KeShi data={data} />}
        {!hasRequestError && type.name === 'XYFY' && <XYFY data={data} />}
        {!hasRequestError && type.name === 'XYFY_ks' && <XYFYKeShi data={data} />}
        {!hasRequestError && type.name === 'ptzx_zc' && <PTZXZC data={data} />}
        {!hasRequestError && type.name === '' && (
          <div id="data-view">
            <FullScreenContainer>
              <Error
                data={{
                  message: '未指定大屏模式，请联系管理员',
                }}
              />
            </FullScreenContainer>
          </div>
        )}
        {!hasRequestError && type.domain === '' && (
          <div id="data-view">
            <FullScreenContainer>
              <Error
                data={{
                  message: '未指定域，请联系管理员',
                }}
              />
            </FullScreenContainer>
          </div>
        )}
      </div>
    </DataContext.Provider>
  )
}

export default App
